import {Component, Injector, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PageInfo} from '../../../../core/models/page-info';
import {MixCartonSearchRequest} from '../../../../core/models/transport-operation/mix-carton-search-request';
import {deepCopy, isNullOrEmpty} from '../../../../core/utils/common-functions';
import {LaasOption} from '../../../../core/models/laas-option';
import {DropdownOptionsService} from '../../../../core/services/dropdown-options.service';
import {AddressMaintainanceService} from '../../../setting/service/address-maintainance.service';
import {SessionBaseComponent} from '../../../../shared/components/session.base.component';
import {DataTableComponent} from '../../../../shared/components/data-table/data-table.component';
import {DeliveryOrderService} from '../../services/delivery-order.service';
import {CommonDataService} from '../../../../core/services/common-data.service';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
@Component({
  selector: 'laas-mix-carton-search',
  templateUrl: './mix-carton-search.component.html',
  styleUrls: ['./mix-carton-search.component.scss']
})
export class MixCartonSearchComponent extends SessionBaseComponent implements OnInit {
  readonly viewPermissionCode = PermissionConstants.MixCartonSearch;
  @ViewChild('MixCartonTable') dataTable!: DataTableComponent;

  currentLang: string = this.laasSetting.language;
  isSearchFormOpen: boolean = true;
  isLoading: boolean = false;
  submitted: boolean = false;

  searchForm: FormGroup;

  brandOptions: LaasOption[];
  internalBrandOptions: LaasOption[];
  consigneeKeyOption: LaasOption[];
  storerOption: LaasOption[];
  orgIdsOptions: LaasOption[];
  mixTypeListOption: LaasOption[];

  commonOption: any;

  pageInfo: PageInfo;
  sortInfo: [{ property: string; direction: number }] | null;


  tableColumns: any[];
  tableValue: any[] = [];

  constructor(injector: Injector,
              private formBuilder: FormBuilder,
              private dropdownOptionsService: DropdownOptionsService,
              private addressMaintainanceService: AddressMaintainanceService,
              private deliveryOrderService: DeliveryOrderService,
              private commonDataService: CommonDataService,
  ) {
    super(injector);

    this.tableColumns = [
      {field: 'storer', header: 'MixCartonSearch.Column.Storer', sort: 'true'},
      {field: 'orgId', header: 'MixCartonSearch.Column.OrgId', sort: 'true'},
      {field: 'consigneeKey', header: 'MixCartonSearch.Column.Consignee', sort: 'true'},
      {field: 'customerName', header: 'MixCartonSearch.Column.ConsigneeName', sort: false},
      {field: 'brand', header: 'MixCartonSearch.Column.Brand', sort: 'true'},
      {field: 'internalBrand', header: 'MixCartonSearch.Column.InternalBrand', sort: 'true'},
      {field: 'deliveryPlace', header: 'MixCartonSearch.Column.DeliveryPlace', sort: 'true'},
      {field: 'mixCartonType', header: 'MixCartonSearch.Column.MixCartonType', sort: 'true'},
      {field: 'mixCondition', header: 'MixCartonSearch.Column.MixCondition', sort: 'true'},
      {field: 'conditionOrder', header: 'MixCartonSearch.Column.ConditionOrder', sort: 'true'},
      {field: 'activeFlag', header: 'MixCartonSearch.Column.ActiveFlag', sort: 'true'},
      {field: 'createDt', header: 'MixCartonSearch.Column.CreateDt', dataType: 'date', sort: 'true'},
      {field: 'createUser', header: 'MixCartonSearch.Column.CreateUser', sort: 'true'},
      {field: 'lastUpdateDt', header: 'MixCartonSearch.Column.LastUpdateDt', dataType: 'date', sort: 'true'},
      {field: 'lastUpdateUser', header: 'MixCartonSearch.Column.LastUpdateUser', sort: 'true'},
    ];

    this.searchForm = this.formBuilder.group({
      brandList: [],
      internalBrandList: [],
      storerList: [null, Validators.required],
      orgIdList: [],
      consigneeKeyList: [],
      activeFlag: null,
      mixTypeList: [],
    });

    this.pageInfo = {
      pageSize: 5,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };

    this.sortInfo = null;

    this.brandOptions = [];
    this.internalBrandOptions = [];
    this.consigneeKeyOption = [];
    this.storerOption = [];
    this.orgIdsOptions = [];
    this.mixTypeListOption = [];

    this.commonOption = [
      {label: 'All', value: null},
      {label: 'Y', value: 'Y'},
      {label: 'N', value: 'N'}
    ];
  }

  async ngOnInit(): Promise<void> {

    this.dropdownOptionsService.getBrandOptions(1).subscribe({
      next: (options: any[]) => {
        this.brandOptions = options.map(x => ({
          label: x.brandName,
          value: x.brandName
        }));
        this.brandOptions.unshift({ label: 'ALL', value: 'ALL' });
        this.internalBrandOptions = [];
      }
    });

    this.addressMaintainanceService.getCustomerOptions().subscribe({
      next: (result) => {
        this.consigneeKeyOption = [...result].map((x: any) => {
          return {
            label: `${x.customerCode} - ${x.customerName}`,
            value: x.customerCode,
          };
        });
        this.consigneeKeyOption.unshift({ label: 'ALL', value: 'ALL' });
      },
    });

    this.addressMaintainanceService.getStorerOptions().subscribe({
      next: (result) => {
        this.storerOption = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}`,
            value: x.optionCode,
          };
        });
        if (this.storerOption.length > 0) {
          this.storerOption.sort((a, b) => a.label.localeCompare(b.label));
        }
      },
    });

    this.dropdownOptionsService.getLetterOrgOptions()
      .subscribe({
        next: (options: any[]) => {
          this.orgIdsOptions = options;
        }
      });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'MixType').subscribe({
      next: result => {
        this.mixTypeListOption = [...result].map((x: any) => {
          return {
            value: x.codeKey,
            label: x.codeDesc,
          };
        });
      }
    });


  }

  tableSort(event: any): void {
    this.sortInfo = [{property: event.field, direction: event.order}];
    this.searchBtnClick();
  }

  tablePageChange(event: any) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.searchBtnClick();
  }

  setPageSize(event: any) {
    this.pageInfo.pageSize = event.rows;
  }

  searchBtnClick() {
    if (this.searchForm.invalid) {
      this.submitted = true;
      this.toastService.warn(this.translateService.instant('ReceiptFormQuery.Alert.CheckRequired'));
      return;
    }
    this.searchMixCarton();
  }

  searchMixCarton() {
    this.isLoading = true;
    this.isSearchFormOpen = false;
    let searchParam: MixCartonSearchRequest = deepCopy(this.searchForm.value);

    if (isNullOrEmpty(searchParam.mixTypeList) || (searchParam.mixTypeList?.length === 0)) {
      searchParam.mixTypeList = this.mixTypeListOption.map((x: any) => x.value);
    }

    searchParam.language = this.laasSetting.language;
    searchParam.pageSize = this.pageInfo.pageSize;
    searchParam.pageIndex = this.pageInfo.pageIndex;
    searchParam.sortInfo = this.sortInfo;
    searchParam.language = this.laasSetting.language
    this.deliveryOrderService.queryMixCartonSetting(searchParam).subscribe({
      next: (result) => {
        this.tableValue = result.mixCartons;
        this.tableValue.forEach((x: any) => {
          x.mixCartonType = this.mixTypeListOption.find((y: any) => y.value === x.mixCartonType)?.label;
        });

        this.pageInfo.totalRecords = result.totalCnt;
        this.isLoading = false;
      }, error: (err) => {
        this.isLoading = false;
        const instantMsg = this.translateService.get("MixCartonSearch.Message.GuiNoMaxLength").toPromise();
        this.toastErrorMessage(instantMsg);
      }
    });
  }

  exportBtnClick() {
    if (this.searchForm.invalid) {
      this.submitted = true;
      this.toastService.warn(this.translateService.instant('ReceiptFormQuery.Alert.CheckRequired'));
      return;
    }
    this.isLoading = true;
    this.isSearchFormOpen = false;
    let searchParam: MixCartonSearchRequest = deepCopy(this.searchForm.value);

    if (isNullOrEmpty(searchParam.mixTypeList) || (searchParam.mixTypeList?.length === 0)) {
      searchParam.mixTypeList = this.mixTypeListOption.map((x: any) => x.value);
    }

    searchParam.language = this.laasSetting.language;
    this.deliveryOrderService.exportMixCartonSetting(searchParam).subscribe({
      next: (result) => {
        this.isLoading = false;
        if (result == null || result.size == 0) {
          this.translateService.get('Common.Toast.NoData').subscribe({
            next: i18nResult => {
              this.toastService.info(i18nResult);
            }
          });
          this.loader.hide();
          return;
        }

        let downloadURL = window.URL.createObjectURL(result);
        let link = document.createElement('a');
        link.href = downloadURL;
        link.download = 'MixCarton Result.xlsx';
        link.click();
      }, error: (err) => {
        this.isLoading = false;
        const instantMsg = this.translateService.get("EvidenceCheck.Message.GuiNoMaxLength").toPromise();
        this.toastErrorMessage(instantMsg);
      }
    });
  }

}
